module.exports = __webpack_public_path__ + "src/assets/individualImages/honeyIcon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/individualImages/honeyIcon.png
// module id = ./src/assets/individualImages/honeyIcon.png
// module chunks = 0